import { ReactElement } from 'react';
import DemandCaptureIcon from './DemandCapture.svg?react';
import DemandGenIcon from './DemandGen.svg?react';

interface DcDgBadgeProps {
  isDemandCapture: boolean;
}

export const DcDgBadge = ({ isDemandCapture }: DcDgBadgeProps): ReactElement =>
  isDemandCapture ? <DemandCaptureIcon /> : <DemandGenIcon />;
